import type { ReadonlyDeep, WritableDeep } from "type-fest";

import { clone as ramdaClone } from "ramda";

function awaitTimeout(delay: number) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

function arrayWrap<Value>(value: Value) {
  if (Array.isArray(value)) {
    return value as Extract<Value, unknown[] | readonly unknown[]>;
  }
  return [value] as Exclude<
    Exclude<Value, unknown[] | readonly unknown[]>[],
    never[]
  >;
}

// oxlint-disable-next-line typescript/no-unnecessary-type-assertion
const clone = ramdaClone as <Param>(
  param: ReadonlyDeep<Param>,
) => WritableDeep<Param>;

export * from "./cookies.ts";
export * from "./credits.enum.ts";
export * from "./currency.enum.ts";
export * from "./currency.ts";
export * from "./dayjs.ts";
export * from "./decodeHtml.ts";
export * from "./deepToString.ts";
export * from "./errorHandling.ts";
export * from "./iban.ts";
export * from "./identity/index.ts";
export * from "./isClient.ts";
export * from "./isEqual.ts";
export * from "./ky.ts";
export * from "./localStorage.ts";
export * from "./memoize.ts";
export * from "./networkErrorHandling.ts";
export * from "./sentryClient.ts";
export * from "./solvariEnv.ts";
export * from "./taxNumber.enum.ts";
export * from "./taxNumber.ts";
export * from "./throttleable.ts";
export { toSearchParams } from "./toSearchParams.ts";
export type * from "./types.ts";
export * from "./url/index.ts";
export * from "./useGlobal.ts";
export * from "./visitor/index.ts";
export { arrayWrap, awaitTimeout, clone };
